import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { locationIdFormat } from "../ids";

export const RedoFulfillmentToteGroupSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  name: z.string(),
  locationId: locationIdFormat.schema.nullish(),
});

export type RedoFulfillmentToteGroup = z.infer<
  typeof RedoFulfillmentToteGroupSchema
>;
